import cx from 'classnames';
import styles from '../../styles/grow-wealth.scss';
import { RentFaqs } from '../../constants/elss';

const FAQs = () => (
  <section
    id="section3"
    className={cx(styles['faq'], styles['pad56'])}
    style={{ borderTop: 'thin solid #999' }}
  >
    <div className="mb15 text--xxlg text-center">{RentFaqs.heading}</div>
    {RentFaqs.qaSet.map((item, i) => {
      return (
        <div key={i} className={cx(styles['qa-container'], 'mb40')}>
          <div className={cx(styles['ques'], 'font--bold mb10 text--lg')}>
            {item.question}
          </div>
          <div className={cx(styles['ans'], 'font--fadedgrey')}>
            {item.answer.preText}
          </div>
        </div>
      );
    })}
  </section>
);

export default FAQs;



// WEBPACK FOOTER //
// ./components/rent/Faqs.tsx